<div class="content-heading">
  <div class="header-container">
    <h3>Reporte de Cambios de Equipo</h3>
    <small>Reporte Web</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default shadow-sm border-0">
    <div class="card-body">
      
      <h5 class="text-primary mb-3"><i class="fa fa-list mr-2"></i>Filtros para Reporte Detalle</h5>
      <div class="row">
        <div class="col-md-4 col-sm-6">
          <label>Origen</label>
          <ng-autocomplete 
            [placeholder]="'Búsqueda'" [data]="nodes" [searchKeyword]="'UnitDescription'"
            [itemTemplate]="itemTpl" [notFoundTemplate]="notFoundTpl" [minQueryLength]="3" 
            (selected)="detailOriginSelected()" (inputCleared)="detailOriginCleared()" [(ngModel)]="detailOrigin">
          </ng-autocomplete>
        </div>
        <div class="col-md-4 col-sm-6">
          <label>Destino</label>
          <ng-autocomplete 
            [placeholder]="'Búsqueda'" [data]="nodes" [searchKeyword]="'UnitDescription'"
            [itemTemplate]="itemTpl" [notFoundTemplate]="notFoundTpl" [minQueryLength]="3" 
            (selected)="detailDestinationSelected()" (inputCleared)="detailDestinationCleared()" [(ngModel)]="detailDestination">
          </ng-autocomplete>
        </div>
        <aph-custom-text class="col-md-4 col-sm-6" label="Etiqueta" [(ngModel)]="detailLabel" placeholder="Folio de etiqueta"></aph-custom-text>
      </div>

      <div class="row mt-3">
        <div class="col-md-5">
          <aph-custom-date-picker 
            [singleMode]="false" labelInicio="Desde (Etiqueta)" labelFin="Hasta (Etiqueta)"
            [maxDate]="maxDate" mode="date" [IsDisabledAll]="downloadingDetail"
            (startDateChange)="detailLabelStartDate = $event" (endDateChange)="detailLabelEndDate = $event"
            (onValidationStatus)="isValidDetailLabel = $event">
          </aph-custom-date-picker>
        </div>
        
        <div class="col-md-5">
          <aph-custom-date-picker 
            [singleMode]="false" labelInicio="Desde (Remisión)" labelFin="Hasta (Remisión)"
            [maxDate]="maxDate" mode="date" [IsDisabledAll]="downloadingDetail"
            (startDateChange)="detailRemStartDate = $event" (endDateChange)="detailRemEndDate = $event"
            (onValidationStatus)="isValidDetailRem = $event">
          </aph-custom-date-picker>
        </div>

        <div class="col-md-2">
          <aph-custom-text label="Remisión" [(ngModel)]="detailRem" placeholder="No."></aph-custom-text>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <aph-custom-buttons 
            preset="excel" label="Descargar reporte Detalle" 
            [loading]="downloadingDetail" [disabled]="!isValidDetailLabel || !isValidDetailRem"
            (btnClick)="downloadDetail()">
          </aph-custom-buttons>
        </div>
      </div>

      <hr class="my-5">

      <h5 class="text-primary mb-3"><i class="fa fa-calculator mr-2"></i>Filtros para Reporte Totales</h5>
      <div class="row">
        <div class="col-md-4 col-sm-6">
          <label>Origen</label>
          <ng-autocomplete 
            [placeholder]="'Búsqueda'" [data]="nodes" [searchKeyword]="'UnitDescription'"
            [itemTemplate]="itemTpl" [notFoundTemplate]="notFoundTpl" [(ngModel)]="totalOrigin">
          </ng-autocomplete>
        </div>
        <div class="col-md-4 col-sm-6">
          <label>Destino</label>
          <ng-autocomplete 
            [placeholder]="'Búsqueda'" [data]="nodes" [searchKeyword]="'UnitDescription'"
            [itemTemplate]="itemTpl" [notFoundTemplate]="notFoundTpl" [(ngModel)]="totalDestination">
          </ng-autocomplete>
        </div>
        <div class="col-md-4 col-sm-6">
          <aph-custom-text label="Remisión" [(ngModel)]="totalRem" placeholder="No. Remisión"></aph-custom-text>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <aph-custom-date-picker 
            [singleMode]="false" labelInicio="Desde" labelFin="Hasta"
            [maxDate]="maxDate" mode="date" [IsDisabledAll]="downloadingTotals"
            (startDateChange)="totalRemStartDate = $event" (endDateChange)="totalRemEndDate = $event"
            (onValidationStatus)="isValidTotalRem = $event">
          </aph-custom-date-picker>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <aph-custom-buttons 
            preset="excel" label="Descargar reporte Totales" 
            [loading]="downloadingTotals" [disabled]="!isValidTotalRem"
            (btnClick)="downloadTotal()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #itemTpl let-item><a [innerHTML]="item.UnitDescription"></a></ng-template>
<ng-template #notFoundTpl let-notFound><div [innerHTML]="'Sin coincidencias'"></div></ng-template>